



















import { PaymentOptionalService } from '../../biz/remote/PaymentOptionalService';
import { OptionalPaymentDTO } from '../../../src_server/entity/dto/OptionalPaymentDTO';
import { Vue, Component } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { Session } from '../../utils/Session';
import { MessageDialog } from '../../utils/MessageDialog';
@Component({ components: { CommonDialog } })
export default class PaymentOptionalEditDialog extends Vue {
  private mode: 'add' | 'edit' = 'add';
  private dto = new OptionalPaymentDTO();
  private userOptions: { value: string; title: string }[] = [];

  /**
   * ダイアログを開く
   */
  public async showAdd() {
    await this.show();
  }

  get userName() {
    return this.userOptions.find((op) => op.value === this.dto.user_auth.user_id)?.title;
  }

  async commit() {
    const biz = new PaymentOptionalService();
    const isOK = await MessageDialog.confirm(`登録します。よろしいですか？`);
    if (!isOK) return;

    if (!Number.parseInt(this.dto.optional_payment.optional_amount)) {
      await MessageDialog.alert(`金額にエラーがあります`);
      return;
    }

    if (this.mode === 'add') {
      await biz.addOptionalPayments(this.dto.optional_payment);
      this.$emit('add', this.dto);
    } else {
      await biz.editOptionalPayments(this.dto.optional_payment);
      this.$emit('edit', this.dto);
    }
    this.close();
  }

  public async showEdit(op: OptionalPaymentDTO) {
    this.mode = 'edit';
    this.dto = op;
    // console.log(this.dto);
    await (this.$refs['PaymentOptionalEditDialog'] as CommonDialog).show();
  }

  private async show() {
    this.mode = 'add';
    this.dto = new OptionalPaymentDTO();
    this.dto.optional_payment.optional_dt = new Date();
    await (this.$refs['PaymentOptionalEditDialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['PaymentOptionalEditDialog'] as CommonDialog).hide();
  }

  async created() {
    const biz = new PaymentOptionalService();
    const response = await biz.getUsers(Session.getSessionBuildingId());
    this.userOptions = response.data;
  }
}
